const DEFAULT_VWO_ACCOUNT_ID = 288689;

class VWOService {
  /**
   * represents VWOService
   * @constructor
   */
  constructor() {
    this.VWO_SCRIPT_ID = 'vwo-script-widget';
    this.accountId = window?.VWO_ACCOUNT_ID || DEFAULT_VWO_ACCOUNT_ID;
    this.settingsTolerance = 5000;
    this.libraryTolerance = 5000;
    this.useExistingJquery = false;
    this.isSpa = 1;
    this.hideElement = 'body';
    this.finished = false;
  }

  /**
   * Method for finishing VWO code insertion
   */
  finish = () => {
    if (!this.finished) {
      this.finished = true;
      const visOpt = document.getElementById('_vis_opt_path_hides');
      if (visOpt) {
        visOpt.parentNode.removeChild(visOpt);
      }
      if (this.hideElement) {
        document.querySelector(this.hideElement).classList.remove('hideBodyElement');
      }
    }
  };

  /**
   * Method for loading script into DOM head
   * @param {string} anchor link for the script that needs to be inserted
   */
  load = (anchor) => {
    const newScript = document.createElement('script');
    newScript.src = anchor;
    newScript.id = this.VWO_SCRIPT_ID;
    newScript.type = 'text/javascript';
    newScript.innerText = undefined;
    newScript.onerror = () => {
      this.finish();
    };
    document.getElementsByTagName('head')[0].appendChild(newScript);
  };

  /**
   * Main method for initializing script
   */
  init = () => {
    window['settings_timer'] = setTimeout(
      () => window?.['_vwo_code']?.finish(),
      this.settingsTolerance
    );

    const styleElement = document.createElement('style');
    if (this.hideElement) {
      document.querySelector(this.hideElement).classList.add('hideBodyElement');
    }
    const headElement = document.getElementsByTagName('head')[0];
    styleElement.setAttribute('id', '_vis_opt_path_hides');
    styleElement.setAttribute('type', 'text/css');
    headElement.appendChild(styleElement);
    this.load(
      `https://dev.visualwebsiteoptimizer.com/j.php?a=${this.accountId}&u=${encodeURIComponent(document.URL)}&f=${+this
        .isSpa}&r=${Math.random()}`
    );

    return window['settings_timer'];
  };

  /**
   * Method to start service running
   */
  startService = () => {
    window['_vwo_settings_timer'] = this.init();
    window['_vwo_code'] = window['_vwo_code'] || {
      'use_existing_jquery': () => this.useExistingJquery,
      'library_tolerance': () => this.libraryTolerance,
      finish: this.finish,
      finished: () => this.finished,
      load: this.load,
      init: this.init,
    };
  };
}

export default new VWOService();
